import {SET_STEP_LIABILITY, SET_GO_TO_LIABILITY, CLEAR_NEW_LIABILITY_POLICY} from '../actions/types';

export const liabilityStepReducer = (state = {} , action) => {
    switch(action.type) {
        case SET_STEP_LIABILITY:
            return {...state, step: action.payload} || {};
        case SET_GO_TO_LIABILITY:
            return {...state, goToLiability: action.payload} || {};
        case CLEAR_NEW_LIABILITY_POLICY:
            return {};
            
        default:
            return state;
    }
}